<template>
  <v-container
    id="detalhe-valor-receber-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :cliente="enableClientes"
          :url="link"
        />
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="11"
                    >
                      <h3 class="text-center">
                        Relação de valores em aberto
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="error">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 18%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedTipo('nome')"
                                >
                                  {{ iconeNome }}
                                </v-icon>
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 18%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedTipo('lancamento')"
                                >
                                  {{ iconeLancamento }}
                                </v-icon>
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 18%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedTipo('data')"
                                >
                                  {{ iconeDiasVencido }}
                                </v-icon>
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          v-if="expandido.nome || expandido.lancamento || expandido.data"
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Cod. lancamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 16%;"
                                class="black--text title"
                              >
                                Data vencimento(dia)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 13%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor emissão
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Valor pago
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 13%;"
                                class="black--text title"
                              >
                                Saldo
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoExibicao"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 18%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 18%;"
                              >
                                {{ item.qtd_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;  width: 18%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 16%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.vlr_emissao }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.vlr_pago }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.saldo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import ContasReceber from '../../../../../services/contasreceber'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardContasAbertoDetalhamento',
    emits: [],
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: true,
      link: localStorage.linkContasReceber,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectClientes: [],
      headersDetalhamento: [
        { text: 'Cod. lancamento', value: 'qtd_lancamento', width: '18%', class: 'black--text title' },
        { text: 'Data vencimento(dia)', value: 'data_vencimento', width: '18%', align: 'left', class: 'black--text title' },
        { text: 'Dias vencido', value: 'dias_vencido', width: '16%', align: 'right', class: 'black--text title' },
        { text: 'Valor emissão', value: 'vlr_emissao', width: '15%', align: 'right', class: 'black--text title' },
        { text: 'Valor pago', value: 'vlr_pago', width: '15%', align: 'right', class: 'black--text title' },
        { text: 'Saldo', value: 'saldo', width: '15%', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      iconeLancamento: 'mdi-plus',
      iconeDiasVencido: 'mdi-plus',
      iconeNome: 'mdi-plus',
      expandLancamento: false,
      expandDiasVencido: false,
      expandLancamentoDiasVencido: false,
      respostaDetalheNomeReduzido: [],
      dadosDetalhamentoLancamento: [],
      dadosDetalhamentoVencimento: [],
      dadosDetalhamentoLancamentoVencimento: [],
      respostaDetalheLancamentoData: [],
      respostaDetalheLancamento: [],
      respostaDetalheData: [],
      respostaDetalheNomeLancamento: [],
      respostaDetalheNomeData: [],
      respostaDetalheNomeLancamentoData: [],
      dadosDetalhamentoExibicao: [],
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dadosDetalhe: {
        nome: [],
        lancamento: [],
        data: [],
        nomeLancamento: [],
        nomeData: [],
        lancamentoData: [],
        nomeLancamentoData: [],
      },
      expandido: {
        nome: false,
        lancamento: false,
        data: false,
      },
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, selectVendedores, selectArea, selectRede, selectSupervisor, selectReceita, selectSegmento, selectClassificacao, selectProduto, selectCidade, selectCategoria, selectPromotor, selectLinhasProducao, primeiroDiaStatus, dateStatus, selectMotorista, selectStatusEntrega, selectOrdem, selectOpcaoOrdenacao, selectOrientacaoOrdem, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.selectClientes = selectClientes

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.dadosDetalhe = {
          nome: [],
          lancamento: [],
          data: [],
          nomeLancamento: [],
          nomeData: [],
          lancamentoData: [],
          nomeLancamentoData: [],
        }

        this.showContasReceberDelhamentoValorAberto()
      },

      async showContasReceberDelhamentoValorAberto () {
        this.loading = true

        await ContasReceber.showDelhamentoValorAberto(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosExibicao.map((item) => {
              var listaDetalhamento = ({
                nome_reduzido: item.nome_reduzido,
                qtd_lancamento: item.qtd_lancamento,
                data_vencimento: item.data_vencimento,
                dias_vencido: item.dias_vencido,
                vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDetalhamento
            })

            this.dadosDetalhe.nome = this.formatarDetalhes(resposta.data.dadosDetalheNomeReduzido)
            this.dadosDetalhe.lancamento = this.formatarDetalhes(resposta.data.dadosDetalheLancamento)
            this.dadosDetalhe.data = this.formatarDetalhes(resposta.data.dadosDetalheData)
            this.dadosDetalhe.nomeLancamento = this.formatarDetalhes(resposta.data.dadosDetalheNomeLancamento)
            this.dadosDetalhe.nomeData = this.formatarDetalhes(resposta.data.dadosDetalheNomeData)
            this.dadosDetalhe.lancamentoData = this.formatarDetalhes(resposta.data.dadosDetalheLancamentoData)
            this.dadosDetalhe.nomeLancamentoData = this.formatarDetalhes(resposta.data.dadosDetalheNomeLancamentoData)
          } else if (resposta.data.msg === 'Não há dados de recebimento no período selecionado') {
            this.dadosDetalhamento = []

            this.dadosDetalhe = {
              nome: [],
              lancamento: [],
              data: [],
              nomeLancamento: [],
              nomeData: [],
              lancamentoData: [],
              nomeLancamentoData: [],
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      formatarDetalhes (dados) {
        return dados.map(item => ({
          nome_reduzido: item.nome_reduzido,
          qtd_lancamento: item.qtd_lancamento,
          data_vencimento: item.data_vencimento,
          dias_vencido: item.dias_vencido,
          vlr_emissao: item.vlr_emissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
          vlr_pago: item.vlr_pago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
          saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        }))
      },

      async expandedNome (value) {
        console.log('expandedNome', value)
      },

      expandedTipo (tipo) {
        this.expandido[tipo] = !this.expandido[tipo]

        this.atualizarDetalhamento()
      },

      atualizarDetalhamento () {
        const ativos = []

        if (this.expandido.nome) {
          ativos.push('nome')

          this.iconeNome = 'mdi-minus'
        } else {
          this.iconeNome = 'mdi-plus'
        }

        if (this.expandido.lancamento) {
          ativos.push('lancamento')

          this.iconeLancamento = 'mdi-minus'
        } else {
          this.iconeLancamento = 'mdi-plus'
        }

        if (this.expandido.data) {
          ativos.push('data')

          this.iconeDiasVencido = 'mdi-minus'
        } else {
          this.iconeDiasVencido = 'mdi-plus'
        }

        const chave = ativos.join('')

        switch (chave) {
          case '':
            this.dadosDetalhamentoExibicao = []
            break

          case 'nome':
            this.dadosDetalhamentoExibicao = this.dadosDetalhe.nome
            break

          case 'lancamento':
            this.dadosDetalhamentoExibicao = this.dadosDetalhe.lancamento
            break

          case 'data':
            this.dadosDetalhamentoExibicao = this.dadosDetalhe.data
            break

          case 'nomelancamento':
            this.dadosDetalhamentoExibicao = this.dadosDetalhe.nomeLancamento
            break

          case 'nomedata':
            this.dadosDetalhamentoExibicao = this.dadosDetalhe.nomeData
            break

          case 'lancamentodata':
            this.dadosDetalhamentoExibicao = this.dadosDetalhe.lancamentoData
            break

          case 'nomelancamentodata':
            this.dadosDetalhamentoExibicao = this.dadosDetalhe.nomeLancamentoData
            break
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #bloco1
    margin-left: -5rem

  #templateLancamentoDias
    margin-left: 19.5rem

  #templateDataVencimentoDias
    margin-left: 2rem

  #templateLancamentoDiasVencimento
    margin-left: 4rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
